module.exports = __webpack_public_path__ + "img/square_checked.60e5829e.png";